import { useEffect, useMemo } from "react";

import { Navigate, useLocation } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { warnToast } from "../components/toast";

import { logWarn } from "../utils/logger";
import detectBrowserLanguage from "detect-browser-language";

function NoMatch() {
  const { t, i18n } = useTranslation();

  const location = useLocation();

  const route = useMemo(() => {
    const brwLang = detectBrowserLanguage();
    let locale = brwLang.split("-")[0];
    if (i18n.languages.includes(locale)) {
      return `/${locale}/`;
    } else {
      return "/en/";
    }
  }, [i18n.languages]);

  useEffect(() => {
    logWarn("NoMatch", "invalid_url", {
      url: location.pathname,
      msg: t(`errors.invalid_url`, t("errors.default")),
    });
    warnToast(
      "NoMatch",
      "invalid_url",
      t(`errors.invalid_url`, t("errors.default")),
      {
        toastId: "invalid_url",
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Navigate to={route} />;
}

export default NoMatch;
